import { DropDown, JsonData, OdinController } from '@myosh/odin-components';
import { t } from 'i18next';
import { Control } from 'react-hook-form';
import { handleHFDropdownChange } from '../../../../helpers/dropdown';
import { VisibleFieldType } from '../../../../redux/config/field-types-api';
import { WidgetType } from '../../types/widget-type';

interface WidgetSecondFieldComponentInterface {
  control: Control;
  secondFieldData?: Array<VisibleFieldType>;
  widgetType?: WidgetType;
}

export const WidgetSecondFieldComponent = ({
  widgetType,
  secondFieldData,
  control,
}: WidgetSecondFieldComponentInterface) => {
  return (
    <div className="my-1">
      <OdinController
        name="secondField"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <DropDown
              allowClear={true}
              label={widgetType?.type.typeValue === 'CROSS_TAB_REPORT' ? t('fieldXAxis') : t('secondField')}
              data={secondFieldData as unknown as JsonData}
              textField="field"
              valueField="field"
              onChange={(value) => handleHFDropdownChange({ value, onChange })}
              value={value}
            />
          );
        }}
      />
    </div>
  );
};
